
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/u-box-container-storage",
      function () {
        return require("private-next-pages/u-box-container-storage/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/u-box-container-storage"])
      });
    }
  